import { render, staticRenderFns } from "./ThgProductsPriceComboCard.vue?vue&type=template&id=6ff39cd3&scoped=true"
import script from "./ThgProductsPriceComboCard.vue?vue&type=script&lang=ts"
export * from "./ThgProductsPriceComboCard.vue?vue&type=script&lang=ts"
import style0 from "./ThgProductsPriceComboCard.vue?vue&type=style&index=0&id=6ff39cd3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff39cd3",
  null
  
)

export default component.exports